module.exports = __webpack_public_path__ + "static/media/close.42415cfa.svg";